export type PhoneNumberType = { link: string, display: string }
export const NUMBERS: {[key: string]: PhoneNumberType} = {
  "CA": { link: "sms:+16476990449", display: "(647) 699-0449" },
  "US": { link: "sms:+12038069620", display: "(203) 806-9620" }
}
